import { ValidationFeedback } from './listValidator'
import * as ListDataManager from '../../listDataManager'
import { ListGovernance } from '../validationTypes'

export function validateDropdownList(
  value: string | undefined,
  listGovernance: ListGovernance,
  values: string[] | null = null,
  errors: ValidationFeedback,
) {
  if (!value) {
    return
  }

  const validValues =
    values ||
    ListDataManager.getUniqueValuesForListColumn(
      listGovernance.list_id,
      listGovernance.list_column_id,
    )

  const metadata = listGovernance.meta
  const allTemplateFieldsTiedToList = metadata.allColumnsInList

  // the first template field should be the identifier for dependent lists
  // we assume these have been sorted by the metadata generator
  const firstTemplateFieldInList = allTemplateFieldsTiedToList[0]
  // TODO: Template Field Checks
  if (
    firstTemplateFieldInList?.field?.list_governance?.multi &&
    firstTemplateFieldInList?.field?.list_governance?.delimiter
  ) {
    const selectedValues = value.split(firstTemplateFieldInList.field.list_governance.delimiter)

    // IMPORTANT NOTE:
    // Since generateUniqueValuesPerColumn shares code with drill-down lists which removes
    // empty values, we need to filter them from selected values so they are not checked against
    // for inclusion in errors.
    selectedValues
      .filter(v => v)
      .forEach(val => {
        if (!validValues.includes(val)) {
          errors.errors.push(`${val} not in list.`)
        }
      })
  } else if (!validValues.includes(value)) {
    errors.errors.push(`Value must be in list`)
  }
}
